import Vue from 'vue'
import Vuex, { Store } from 'vuex'
import createLogger from 'vuex/dist/logger'

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    state: {
        profilePhoto: require('../assets/pictures/profile.png'),//"/dist/profile.png",
        guidUser: null,
        userToken: null,
        userName: null,
        user: null,
        email: null,
        guidClient: null,
        clientName: null,
        clientEdrpo: null,
        ip: null,
        google_api: 'AIzaSyBk3tcGQvTlT3CLfXnhHv7ebh6tXfsMKnA',
        
        listRole: {
            client: false,
            dispatcher: false,
            service: false,
            serviceOrg: false,
            admin: false,
            user: true,
            roleCourier: false,
        },

        client: null,
        menuOpened: true,//for menu sidebar logotype

        resultQR: null,//not necessary
        active_qr: false,//needed for modal QR window
        camera: false,

        modalBody: false,//for modalForm component
        modalExecutor: false,//for modal Executors

        active_cam: false,//needed for modal camera window

        roles:[
            {val: "client"},
            {val: "dispatcher"},
            {val: "service"},
            {val: "serviceOrg"},
        ],
        typesTask:[
            /*{name: 'Запуск обладнання', val: 1}, 
            {name: 'Ремонт обладнання', val: 2},
            {name: 'ТО (поза план)', val: 3},
            {name: 'ТО (регламент)', val: 4},*/
            {text: 'tasks.types.vnutr', val: '000000009'},
            {text: 'tasks.types.demontaj', val: '000000006'},
            {text: 'tasks.types.diagnostix', val: '000000003'},
            {text: 'tasks.types.montaj', val: '000000002'},
            {text: 'tasks.types.prepare', val: '000000001'},
            {text: 'tasks.types.rekl_m', val: '000000007'},
            {text: 'tasks.types.rekl_r', val: '000000008'},
            {text: 'tasks.types.remont', val: '000000005'},
            {text: 'tasks.types.to', val: '000000004'},
        ],
        taskStatus: [
            {name: 'tasks.statuses.all', value: '', id: 0},
            {name: 'tasks.statuses.new',value: 'new', id: 1},
            {name: "tasks.statuses.agreed", value: "agreed", id: 2},
            //{name: "tasks.statuses.edit", value: "edit", id: 3},
            {name: "tasks.statuses.bring", value: "bring", id: 8},
            {name: "tasks.statuses.process", value: "process", id: 4},
            {name: "tasks.statuses.finish", value: "finish", id: 5},
            //{name: "tasks.statuses.done", value: "done", id: 6},
            {name: "tasks.statuses.cancel", value: "cancel", id: 7},
            
        ],
        priority:[
            {id: 1, word: "priority.statuses.1.word"},
            {id: 2, word: "priority.statuses.2.word"},
            {id: 3, word: "priority.statuses.3.word"}
        ],

        isLoading: false,//global loader animation
        queries: [],//queue for loader animation

        //newTask: {serials: [],},

        langMap: 'en',
        mapDashShow: false,

        isGPS: false,
        queueGeo: [],//queue for loader of gps

        iconsFiles:{
            excell: require('./../assets/icons/excell.png'),
            img: require('./../assets/icons/img.png'),
            pdf: require('./../assets/icons/pdf.png'),
            word: require('./../assets/icons/word.png'),
            powerpoint: require('../assets/icons/powerpoint.png'),
            text: require('./../assets/icons/text.png'),
            archive: require('./../assets/icons/archive.png'),
            visio: require('./../assets/icons/visio.png'),
        },
        eq_type: [
            {name: 'Branding', id: 2, translate: 'equipm.types.brand'},
            {name: 'Refrigeration', id: 1, translate: 'equipm.types.refr'},
            {name: 'Parcel Terminal', id: 3, translate: 'equipm.types.boxes'},
            {name: 'Other products', id: 4, translate: 'equipm.types.other'},
            {name: 'Checkouts', id: 5, translate: 'equipm.types.checkouts'}
        ],

        categories: [
            {title: 'problem.categ.lock', id: 1, class: 'icon-lock'},
            {title: 'problem.categ.lockContr', id: 2, class: 'icon-shrink'},
            {title: 'problem.categ.scan', id: 3, class: 'icon-barcode'},
            {title: 'problem.categ.displ', id: 4, class: 'icon-display'},
            {title: 'problem.categ.camera', id: 5, class: 'icon-camera5'},
            {title: 'problem.categ.bbg', id: 6, class: 'icon-trending_down'},
            {title: 'problem.categ.commut', id: 7, class: 'icon-enlarge'},
            {title: 'problem.categ.control', id: 8, class: 'icon-command'},
            {title: 'problem.categ.router', id: 9, class: 'icon-wifi3'},
            {title: 'problem.categ.hdd', id: 10, class: 'icon-database'},
            {title: 'problem.categ.contrLed', id: 11, class: 'icon-sun'},
            {title: 'problem.categ.vertHeat', id: 12, class: 'icon-texture'},
            {title: 'problem.categ.ant', id: 13, class: 'icon-podcast'},
            {title: 'problem.categ.concentr', id: 14, class: 'icon-insert-template'}
        ],
        errors: [],
        
    },
    modules: {},
    strict: false,
    plugins: debug ? [createLogger()] : [],
    actions:{},
    getters:{
        getCurrentUser: (state, getters, rootState) => {
            return state.client;
        },
        getProfilePhoto: state => {
            return state.profilePhoto;
        },
        /*getNewTaskSerials: state => {
            return state.newTask.serials;
        },*/
        getClient: state => {
            return state.listRole.client;
        },
        getDispatcher: state => {
            return state.listRole.dispatcher;
        },
        getService: state => {
            return state.listRole.service;
        },
        getServiceOrg: state => {
            return state.listRole.serviceOrg;
        },
        getAdmin: state => {
            return state.listRole.admin;
        },
        getUser: state => {
            return state.listRole.user;
        },
        getRoleCourier: state => {
            return state.listRole.roleCourier;
        },
        getUserToken: state => {
            return state.userToken;
        },
        getGuidUser: state => {
            return state.guidUser;
        },
        getCamera: state => {
            return state.camera;
        },
        getErrors: state => {
            return state.errors;
        },
        getTypesTask: state => {
          return state.typesTask;
      },

    },
    mutations: {
        setCurrentUser(state, user) {
            state.client = user
        },
        setProfilePhoto(state, image){
            state.profilePhoto = image;
        },
        /*addSerialNewTask(state,item){
            state.newTask.serials.push(item);
        },
        deleteSerialNewTask(state, index){
            state.newTask.serials.splice(index,1);
        },
        emptySerialsNewTask(state){
            state.newTask.serials = [];
        },*/
        setClient(state, bool){
            state.listRole.client = bool;
        },
        setDispatcher(state, bool){
            state.listRole.dispatcher = bool;
        },
        setService(state, bool){
            state.listRole.service = bool;
        },
        setServiceOrg(state, bool){
            state.listRole.serviceOrg = bool;
        },
        setAdmin(state, bool){
            state.listRole.admin = bool;
        },
        setUser(state, bool){
            state.listRole.user = bool;
        },
        setRoleCourier(state, bool){
            state.listRole.roleCourier = bool;
        },
        setUserToken(state, token){
            state.userToken = token;
        },
        setGuidUser(state, guid){
            state.guidUser = guid;
        },
        setCamera(state, bool){
            state.camera = bool;
        },
        addError(state,item){
            state.errors.push(item);
        },
        deleteError(state, index){
            state.errors.splice(index,1);
        },
        emptyErrors(state){
            state.errors = [];
        },
        addtypesTask(state,item){
          state.typesTask.push(item);
        },
        emptytypesTask(state){
          state.typesTask = [];
      },

    }

})


// WEBPACK FOOTER //
// ./src/store/index.js